import React, {useState} from 'react';
import { useParams } from 'react-router';
import {Button, Col, Row, Spinner} from "react-bootstrap";
import styles from './transfer-confirmation.module.scss';
import {FormGroup} from "../../../../../components/form/form";
import SecondaryMarketService from "../../../../../services/secondary-market-service";
import {toCurrency} from "../../../../../helpr/helper";
import {getGraduatedTaxStatusTypes, getTaxStatusTypes} from "../../../../../helpr/transferFormData";
import numToWords from "../../../../../helpr/numToWords";

const TransferConfirmation = ({context, controls}) => {
  const [loading, setLoading] = useState(false);
  const [checkboxState, setCheckboxState] = useState(false);
  const {next, back} = controls;
  const { initialTransferInfoState, transferFormState } = context;
  const secondaryMarketService = new SecondaryMarketService();
  //Retrieve security id from params
  const { transferId }  = useParams();
  const onConfirm = () => {
    setCheckboxState(!checkboxState);
  }
  const submit = async () => {
    setLoading(true);
    try {
      await secondaryMarketService.submitTransfer(transferId, transferFormState);
      setLoading(false);
      next();
    } catch(error) {
      console.log(error.message);
    }
  }

  const renderTaxStatusValue = key => getTaxStatusTypes().filter(t => t.value === key)[0]?.name;
  const renderGradTaxStatusValue = key => getGraduatedTaxStatusTypes().filter(t => t.value === key)[0]?.name;
  return (
    <div className={styles['form-section']}>
      <Row>
        <Col lg={12}>
          <FormGroup header={'TRANSFER INSTRUCTION SUMMARY'}>
            <Row>
              <Col lg={6} className={styles['label']}>Bond Holder</Col>
              <Col lg={6} className={styles['value']}>
                { transferFormState.title ? transferFormState.title : transferFormState.salutation }{' '}
                {`${transferFormState.firstName} ${transferFormState.middleName} ${transferFormState.lastName}`}
              </Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Email Address</Col>
              <Col lg={6} className={styles['value']}>{initialTransferInfoState.emailAddress}</Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Security Name</Col>
              <Col lg={6} className={styles['value']}>{initialTransferInfoState.securityName}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Security ID/ISIN</Col>
              <Col lg={6} className={styles['value']}>{initialTransferInfoState.securityId}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Order Amount (in figure)</Col>
              <Col lg={6} className={styles['value']}>{transferFormState.transferAmount}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Order Amount (in words)</Col>
              <Col lg={6} className={styles['value']}>{numToWords()(parseFloat(transferFormState.transferAmount.replaceAll(',','')))}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Purchase Date</Col>
              <Col lg={6} className={styles['value']}>
                {transferFormState.purchaseDate ? transferFormState.purchaseDate : '-' }
              </Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Tax Status</Col>
              <Col lg={6} className={styles['value']}>{renderTaxStatusValue(transferFormState.taxStatus)}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Graduated Tax Status</Col>
              <Col lg={6} className={styles['value']}>
                {transferFormState.graduatedTaxStatus ? renderGradTaxStatusValue(transferFormState.graduatedTaxStatus) : '-'}
              </Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Broker Name</Col>
              <Col lg={6} className={styles['value']}>{initialTransferInfoState.brokerName}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Transfer Date</Col>
              <Col lg={6} className={styles['value']}>{transferFormState.transferDate}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Settlement Date</Col>
              <Col lg={6} className={styles['value']}>{transferFormState.settlementDate}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Registry BP ID</Col>
              <Col lg={6} className={styles['value']}>{transferFormState.fromRegistryBpId}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Account Number</Col>
              <Col lg={6} className={styles['value']}>{transferFormState.fromRegistryAccountNumber}</Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>To</Col>
              <Col lg={6} className={styles['value']}>{transferFormState.toType}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Depository BP ID</Col>
              <Col lg={6} className={styles['value']}>{transferFormState.toDepositoryBpId}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Account Number</Col>
              <Col lg={6} className={styles['value']}>{transferFormState.toDepositoryAccountNumber}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Registry BP ID</Col>
              <Col lg={6} className={styles['value']}>{transferFormState.toRegistryBpId}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Account Number</Col>
              <Col lg={6} className={styles['value']}>{transferFormState.toRegistryAccountNumber}</Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Non-Stock/Non-Profit</Col>
              <Col lg={6} className={styles['value']}>{transferFormState.nonStockProfit}</Col>
            </Row>
            <Row>
              <Col lg={12}><div className={styles['line']}></div></Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Tax Status</Col>
              <Col lg={6} className={styles['value']}>{renderTaxStatusValue(transferFormState.toTaxStatus)}</Col>
            </Row>
            <Row>
              <Col lg={6} className={styles['label']}>Graduated Tax Status</Col>
              <Col lg={6} className={styles['value']}>
                {transferFormState.toGraduatedTaxStatus ? renderGradTaxStatusValue(transferFormState.toGraduatedTaxStatus) : '-' }
              </Col>
            </Row>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <FormGroup header={'BOND HOLDER CONFIRMATION'}>
            <Row>
              <Col lg={12}>
                <div className={styles['section-spacing']}>
                  <span className={styles['sub-label']}>
                    I/We hereby confirm the currency and correctness of the information herein provided and likewise confirm that the foregoing transfer instruction is legal, valid and binding and may be fully and unconditionally relied upon by PDTC. I/We likewise confirm that I/we have paid the applicable taxes in relation to the transaction; and should the same be incorrect, I/we agree to be liable for additional taxes, duties, assessments or governmental charges with respect there to. I/We hold PDTC free and harmless from any liability, loss or damage that may arise from its execution of the foregoing instruction. I/We recognize and agree that the transfer is subject to the PDTC Registry Rules that are in force and effect.
                  </span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className={styles['section-spacing']}>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <input type="checkbox" onChange={onConfirm}/>
                {' '}
                I confirm.
              </Col>
            </Row>
          </FormGroup>
        </Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col xs={6} lg={6}>
          <div className={styles['back-button']}>
            <Button variant="secondary" onClick={() => back()}>
              BACK
            </Button>
          </div>
        </Col>
        <Col xs={6} lg={6}>
          <div className={styles['submit-button']}>
            <Button disabled={loading || !checkboxState} onClick={() => submit()}>
              {loading ? <Spinner size="sm" animation="border"/> : 'SUBMIT'}
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default TransferConfirmation;
